parasails.registerPage('new-member', {
  //  ╦╔╗╔╦╔╦╗╦╔═╗╦    ╔═╗╔╦╗╔═╗╔╦╗╔═╗
  //  ║║║║║ ║ ║╠═╣║    ╚═╗ ║ ╠═╣ ║ ║╣
  //  ╩╝╚╝╩ ╩ ╩╩ ╩╩═╝  ╚═╝ ╩ ╩ ╩ ╩ ╚═╝
  data: {
    overallEventID: '',
    qrslug: '',
    fixedStampID: '',
    showFooter: true,
    useDarkLogos: true,
    // Form data
    formData: {
      accountRole: 'member'
    },
    // For tracking client-side validation errors in our form.
    // > Has property set to `true` for each invalid property in `formData`.
    formErrors: { /* … */ },
    // Form rules
    formRules: {
      firstName: {required: true},
      lastName: {required: true},
      emailAddress: {required: true, isEmail: true},
      mobileNumber: {required: true, isMobile: true},
      password: {
        required: true,
        custom: (value) => {
          // Check for minimum length
          if (value.length < 8) {
            return false;
          }
          // Check for at least one uppercase letter
          if (!/[A-Z]/.test(value)) {
            return false;
          }
          // Check for at least one lowercase letter
          if (!/[a-z]/.test(value)) {
            return false;
          }
          // Check for at least one number
          if (!/[0-9]/.test(value)) {
            return false;
          }
          return true;
        }
      },
      confirmPassword: {required: true, sameAs: 'password'},
      agreed: {required: true}
    },
    // Syncing / loading state
    syncing: false,
    // Server error state
    cloudError: '',
    // Success state when form has been submitted
    cloudSuccess: false,
    showPassword: false,
    signupMessage: '',
    eventLogo: 'images/caramel-logo.png',
  },

  //  ╦  ╦╔═╗╔═╗╔═╗╦ ╦╔═╗╦  ╔═╗
  //  ║  ║╠╣ ║╣ ║  ╚╦╝║  ║  ║╣
  //  ╩═╝╩╚  ╚═╝╚═╝ ╩ ╚═╝╩═╝╚═╝
  beforeMount: function() {
    const urlParams = new URLSearchParams(window.location.search);
    this.overallEventID = urlParams.get('eventID');
    this.qrslug = urlParams.get('qrslug') || '';
    this.fixedStampID = urlParams.get('fixedStampID') || '';
    this.formData.eventID = this.overallEventID;
  },
  mounted: async function() {
    this.setLogo();
  },

  //  ╦╔╗╔╔╦╗╔═╗╦═╗╔═╗╔═╗╔╦╗╦╔═╗╔╗╔╔═╗
  //  ║║║║ ║ ║╣ ╠╦╝╠═╣║   ║ ║║ ║║║║╚═╗
  //  ╩╝╚╝ ╩ ╚═╝╩╚═╩ ╩╚═╝ ╩ ╩╚═╝╝╚╝╚═╝
  methods: {
    setLogo() {
      if(this.eventData && this.eventData.logoImage) {
        this.eventLogo = this.eventData.logoImage;
      }
      if(this.eventData && this.eventData.subLogoImage) {
        this.subLogo = this.eventData.subLogoImage;
      }
    },
    submittedForm: async function() {
      if (this.qrslug) {
        window.location = '/rally/entry/' + encodeURIComponent(this.qrslug);
        return;
      }
      if (this.fixedStampID) {
        window.location = '/rally/fixed/' + encodeURIComponent(this.overallEventID) + '/' + encodeURIComponent(this.fixedStampID);
        return;
      }
      if (this.overallEventID) {
        window.location = '/rally?eventID=' + encodeURIComponent(this.overallEventID);
        return;
      }
      this.cloudSuccess = true;
    },
  }
});
